import React from 'react';
import { TYPE_HEX } from '../data/trackColors';
import Icon from './Icon';

export const TYPE_META = {
  meal:     { icon: 'utensils',     label: 'Meal',     color: 'var(--type-meal)' },
  panel:    { icon: 'presentation', label: 'Panel',    color: 'var(--type-panel)' },
  keynote:  { icon: 'mic',          label: 'Keynote',  color: 'var(--type-keynote)' },
  insights: { icon: 'lightbulb',    label: 'Insights', color: 'var(--type-insights)' },
  social:   { icon: 'users',        label: 'Social',   color: 'var(--type-social)' },
  golf:     { icon: 'flag',         label: 'Activity', color: 'var(--type-golf)' },
  break:    { icon: 'coffee',       label: 'Break',    color: 'var(--type-break)' },
  general:  { icon: 'mic',          label: 'Session',  color: 'var(--type-general)' },
};

export default function TypeChip({ type }) {
  const meta = TYPE_META[type] || TYPE_META.break;
  const hex = TYPE_HEX[type] || TYPE_HEX.break;
  return (
    <span
      className="portal-type-chip"
      style={{
        color: hex,
        background: `color-mix(in srgb, ${hex} 12%, white)`,
        borderColor: `color-mix(in srgb, ${hex} 20%, white)`,
      }}
    >
      <Icon name={meta.icon} size={12} className="portal-type-icon" />
      <span>{meta.label}</span>
    </span>
  );
}
